import { usePermissions } from '@/hooks/usePermissions'
import type { UiAccessType } from './types'

// Права на вкладки «Доступов». Пока право не заведено в БД — вкладка видна всем
// (hasPermissionOrFallback с fallback = true), чтобы фронт можно было выкатить раньше SQL.
export const ACCESS_TYPE_PERMISSIONS: Record<UiAccessType, string> = {
  guest: 'access.guest',
  white: 'access.white',
  abonement: 'access.white',
  black: 'access.black',
}

export const useAllowedAccessTypes = () => {
  const { hasPermissionOrFallback } = usePermissions()

  const isAccessTypeAllowed = (accessType: UiAccessType) =>
    hasPermissionOrFallback(ACCESS_TYPE_PERMISSIONS[accessType], true)

  return { isAccessTypeAllowed }
}
